import { render, staticRenderFns } from "./KoreanLiveCartNew.vue?vue&type=template&id=1a25817f&scoped=true"
import script from "./KoreanLiveCartNew.vue?vue&type=script&lang=js"
export * from "./KoreanLiveCartNew.vue?vue&type=script&lang=js"
import style0 from "./KoreanLiveCartNew.vue?vue&type=style&index=0&id=1a25817f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a25817f",
  null
  
)

export default component.exports